import { OfferPrintOptionsTextMap } from '../models/offer.model';
import { ProductGroup } from '../services/products.service';

function hasText(map?: OfferPrintOptionsTextMap): boolean {
    const nonEmpty =
        map?.textItems?.filter((i) => !!i.textContent?.trim().length || !!i.textModuleName?.trim().length) || [];
    return nonEmpty.length > 0;
}

export function isGroupWithHintText(group: ProductGroup) {
    return hasText(group.printOptions?.textMap?.POS_BEFORE) || hasText(group.printOptions?.textMap?.POS_AFTER);
}
